
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes03On as ObiDiodes03OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-03-on.js';
 
 
 

 
 export const ObiDiodes03On = createComponent({
   react: React,
   tagName: 'obi-diodes-03-on',
   elementClass: ObiDiodes03OnElement,
   events: {
     
   }
  });
 
 